const TRANSLATION_KEYS = {
  JANUARY: "JANUARY",
  FEBRUARY: "FEBRUARY",
  MARCH: "MARCH",
  APRIL: "APRIL",
  MAY: "MAY",
  JUNE: "JUNE",
  JULY: "JULY",
  AUGUST: "AUGUST",
  SEPTEMBER: "SEPTEMBER",
  OCTOBER: "OCTOBER",
  TRANSACTIONS: "TRANSACTIONS",
  NOVEMBER: "NOVEMBER",
  DECEMBER: "DECEMBER",
  MONDAY_SHORT: "MONDAY_SHORT",
  TUESDAY_SHORT: "TUESDAY_SHORT",
  WEDNESDAY_SHORT: "WEDNESDAY_SHORT",
  THURSDAY_SHORT: "THURSDAY_SHORT",
  FRIDAY_SHORT: "FRIDAY_SHORT",
  SATURDAY_SHORT: "SATURDAY_SHORT",
  SUNDAY_SHORT: "SUNDAY_SHORT",
  START_DATE: "START_DATE",
  END_DATE: "END_DATE",
  WELCOME: "WELCOME",
  PAID: "PAID",
  GRAVITY_DESC_LOGIN: "GRAVITY_DESC_LOGIN",
  PIN: "PIN",
  CANCEL_TICKET: "CANCEL_TICKET",
  SIGN_IN: "SIGN_IN",
  USERNAME: "USERNAME",
  PASSWORD: "PASSWORD",
  SOMETHING_WENT_WRONG: "SOMETHING_WENT_WRONG",
  PLEASE_WAIT_FOR_LOADER: "PLEASE_WAIT_FOR_LOADER",
  GAMES: "GAMES",
  PLACED_BETS: "PLACED_BETS",
  BALANCE: "BALANCE",
  LIMIT: "LIMIT",
  LOGOUT: "LOGOUT",
  SIGN_IN_TITLE: "SIGN_IN_TITLE",
  ENTER_THE_BARCODE: "ENTER_THE_BARCODE",
  CHECK: "CHECK",
  BARCODE: "BARCODE",
  LAST_TICKET: "LAST_TICKET",
  CHECK_AGAIN: "CHECK_AGAIN",
  PAY: "PAY",
  TICKET_IS_PAID: "TICKET_IS_PAID",
  TICKET_SHOULD_BE_PAID_OUT: "TICKET_SHOULD_BE_PAID_OUT",
  DATE: "DATE",
  ROUND_ID: "ROUND_ID",
  BET_AMOUNT: "BET_AMOUNT",
  WINNING_AMOUNT: "WINNING_AMOUNT",
  PAID_AMOUNT: "PAID_AMOUNT",
  PAYMENT_TIME: "PAYMENT_TIME",
  BET_STATUS: "BET_STATUS",
  WON: "WON",
  LOST: "LOST",
  PENDING: "PENDING",
  RETURNED: "RETURNED",
  TICKETS: "TICKETS",
  OVERVIEW: "OVERVIEW",
  GAME: "GAME",
  SEARCH_BARCODE: "SEARCH_BARCODE",
  STATUS: "STATUS",
  RESET: "RESET",
  APPLY: "APPLY",
  WINNING_PAID: "WINNING_PAID",
  ALL_TICKETS: "ALL_TICKETS",
  WON_TICKETS: "WON_TICKETS",
  LOST_TICKETS: "LOST_TICKETS",
  BETS_ACCEPTED: "BETS_ACCEPTED",
  GAMES_NAV: "GAMES_NAV",
  STAKE: "STAKE",
  TICKET_STAKE: "TICKET_STAKE",
  WIN: "WIN",
  LOSE: "LOSE",
  CANCELED: "CANCELED",
  UNKNOWN: "UNKNOWN",
  CALCULATION: "CALCULATION",
  ON_CANCEL: "ON_CANCEL",
  TOTAL_BET: "TOTAL_BET",
  TOTAL_WIN_AMOUNT: "TOTAL_WIN_AMOUNT",
  TOTAL_ODDS: "TOTAL_ODDS",
  POSSIBLE_WIN: "POSSIBLE_WIN",
  BET_TYPE: "BET_TYPE",
  SINGLE: "SINGLE",
  EXPRESS: "EXPRESS",
  GAME_NAME: "GAME_NAME",
  PROVIDERS: "PROVIDERS",
  ADMIN: "ADMIN",
  DEPOSIT: "DEPOSIT",
  WITHDRAW: "WITHDRAW",
  SUCCESS: "SUCCESS",
  BALANCE_CLUB: "BALANCE_CLUB",
  CURRENT: "CURRENT",
  BALANCE_OPERATIONS: "BALANCE_OPERATIONS",
  CASHIER: "CASHIER",
  MARKET_NAME: "MARKET_NAME",
  TICKET_ID: "TICKET_ID",

  TICKET_STATUS: "TICKET_STATUS",
  DAY: "DAY",
  MY_BETS: "MY_BETS",
  COPY: "COPY",
  RESULT: "RESULT",
  FAIRNESS: "FAIRNESS",
  KEY: "KEY",
  CHECK_HASH_CODE: "CHECK_HASH_CODE",
  SALT: "SALT",
  HASH_CODE: "HASH_CODE",
  SCAN_TO_CHECK_FAIRNESS: "SCAN_TO_CHECK_FAIRNESS",
  TOTAL_POSSIBLE_WIN: "TOTAL_POSSIBLE_WIN",
  AMOUNT: "AMOUNT",
  MAX_PAY_OUT_AMOUNT_RANGE: "MAX_PAY_OUT_AMOUNT_RANGE",
  NOT_FOUND: "NOT_FOUND",
  ERROR: "ERROR",
  BACK_TO_DASHBOARD: "BACK_TO_DASHBOARD",
  PAGE_NOT_FOUND: "PAGE_NOT_FOUND",
  ODD: "ODD",
  BET: "BET",
  CASHIER_NAME: "CASHIER_NAME",
  REMEMBER_ME: "REMEMBER_ME",

  //JACKPOT
  ID: "ID",
  MEGA: "MEGA",
  NAME: "NAME",
  LEVELS: "LEVELS",
  JACKPOT: "JACKPOT",
  BETSHOP: "BETSHOP",
  PAY_OUT: "PAY_OUT",
  JACKPOT_ID: "JACKPOT_ID",
  CURRENT_POT: "CURRENT_POT",
  JACKPOT_INFO: "JACKPOT_INFO",
  JACKPOT_TYPE: "JACKPOT_TYPE",
  JACKPOT_LEVEL: "JACKPOT_LEVEL",
  JACKPOT_AMOUNT: "JACKPOT_AMOUNT",
  JACKPOT_BARCODE: "JACKPOT_BARCODE",
  BETSHOP_LIST: "BETSHOP_LIST",
  GAME_LIST: "GAME_LIST",
  SHOW_JACKPOT: "SHOW_JACKPOT",
  LEVEL: "LEVEL",

  ROUND_RESULT: "ROUND_RESULT",
  SIGN_IN_TO_YOUR_ACCOUNT: 'SIGN_IN_TO_YOUR_ACCOUNT',
  CONGRATULATIONS: 'CONGRATULATIONS',
  YOU_WON_JACKPOT: 'YOU_WON_JACKPOT',


  SEND_MONEY_TO: "SEND_MONEY_TO",
  GET_MONEY_FROM: "GET_MONEY_FROM",
  TRANSFER: "TRANSFER",
  ENCASHMENT: "ENCASHMENT",
  CASH_IN: "CASH_IN",
  CASH_OUT: "CASH_OUT",
  PARTNER: "PARTNER",
  SUPER_ADMIN: "SUPER_ADMIN",
  MANAGER: "MANAGER",
  RECEIVER_ROLE: "RECEIVER_ROLE",
  RECEIVER: "RECEIVER",
  SENDER: "SENDER",
  SENDER_ROLE: "SENDER_ROLE",
  COMMENT: "COMMENT",
  BALANCE_MANAGEMENT_REQUEST: "BALANCE_MANAGEMENT_REQUEST",
  BALANCE_MONITORING: "BALANCE_MONITORING",
  REQUEST: "REQUEST",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  SEEN: "SEEN",
  TRANSACTION_TYPE: "TRANSACTION_TYPE",
  SEND: "SEND",
  RECEIVE: "RECEIVE",
  BALANCE_REQUEST_GET_MESSAGE: "BALANCE_REQUEST_GET_MESSAGE",
  BALANCE_REQUEST_SEND_MESSAGE: "BALANCE_REQUEST_SEND_MESSAGE",
  PLEASE_APPROVE_BY_FILLING_THE_CODE: "PLEASE_APPROVE_BY_FILLING_THE_CODE",
  DENY: "DENY",
  ACCEPT: "ACCEPT",
  REQUEST_SUCCESS_ACTION: "REQUEST_SUCCESS_ACTION",
  APPROVE: "APPROVE",
  REQUESTS: "REQUESTS",
  REQUEST_SUCCESS_MESSAGE: "REQUEST_SUCCESS_MESSAGE",
  REQUEST_REJECT_MESSAGE: "REQUEST_REJECT_MESSAGE",
  POSSIBLE_COMBINATIONS: "POSSIBLE_COMBINATIONS",
  COMBINATIONS: "COMBINATIONS",
  SYSTEM: "SYSTEM",
};

export { TRANSLATION_KEYS as T };
